import React from 'react';
import styles from './Skills.module.scss'
import {withRouter} from 'react-router-dom'
import Ico from './ico'
import Ico2 from './Ico2'


const Skills = (props) => {
    return (
        <React.Fragment>
           <div> <h2>Навыки</h2></div>
            <div className={styles.skills}>
                <div className={styles.skills_js}>
                    <span> <Ico/> JavaScript ES6+</span>
                    <span><Ico/> React</span>
                    <span><Ico/> Node js</span>
                    <span><Ico/> CSS3</span>
                    <span><Ico/> HTML5</span>
                    <span><Ico/> SASS/SCSS</span>
                    <span><Ico/> JSON</span>
                    <span><Ico/> HTTP</span>
                    <span><Ico/> Git</span>
                    <span><Ico/> MySQL</span>
                    <span><Ico/> MongoDB</span>

                </div>
                <div className={styles.skills_python}>
                    <span><Ico/> Python</span>
                    <span><Ico/> Django</span>
                    <span><Ico/> DRF</span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className={styles.skills_image}>
                    <Ico2 x={props.x}/>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Skills);
